module.exports = __webpack_public_path__ + "static/media/Foodtopia-mobile.004ce6cd.jpg";